export default __webpack_public_path__ + "static/media/edit@3x.97fa5584.svg";